import { combineReducers } from 'redux'

import loading from './loading'
import user from './user'
import users from './users'
import nav from './nav'
import projects from './projects'
import contacts from './contacts'
import contactLogs from './contactLogs'
import messages from './messages'
import stats from './stats'
import appointments from './appointments'
import projectUsers from './projectUsers'
import companies from './companies'

const reducer = combineReducers({
  loading,
  user,
  users,
  nav,
  projects,
  contacts,
  contactLogs,
  messages,
  stats,
  appointments,
  projectUsers,
  companies
})

export default reducer



// WEBPACK FOOTER //
// ./src/reducers/index.js